import { render } from "./CustomerRegistrationModal.vue?vue&type=template&id=14ee98fc"
import script from "./CustomerRegistrationModal.vue?vue&type=script&lang=js"
export * from "./CustomerRegistrationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__